import validate from "/home/user/www/admin.qcontrol.su/node_modules/nuxt/dist/pages/runtime/validate.js";
import sanctum_58auth_58global from "/home/user/www/admin.qcontrol.su/node_modules/nuxt-auth-sanctum/dist/runtime/middleware/sanctum.global.js";
import manifest_45route_45rule from "/home/user/www/admin.qcontrol.su/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  sanctum_58auth_58global,
  manifest_45route_45rule
]
export const namedMiddleware = {}